module.exports = __webpack_public_path__ + "media/src/images/icons/share/primary-25dda2e2971a98ae61261541a4960f1f.svg";